import { Component, EventEmitter, Input, OnChanges, Output, } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss']
})
export class NavItemComponent implements OnChanges {
  constructor(private router: Router,) {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.getActivatedRoutes())
  }

  @Input() path: string = ""
  @Input() label: string = ""
  @Input() isCollapsed: boolean = false
  @Output() changeRoute: EventEmitter<any> = new EventEmitter<string>()

  active = false
  url = `../../../../assets/icons/${this.label}.svg`
  active_url = `../../../../assets/icons/active-${this.label}.svg`

  navigate = () => {
    this.router.navigate([this.path])
    this.changeRoute.emit(this.label)
  }

  getActivatedRoutes = () => {
    if (this.router.url === this.path && this.path === "/dashboard") {
      this.active = true
      this.url = `../../../../assets/icons/${this.label}.svg`
      this.active_url = `../../../../assets/icons/active-${this.label}.svg`
    } else if (this.router.url.includes(this.path) && this.path !== "/dashboard") {
      this.active = true
      this.url = `../../../../assets/icons/${this.label}.svg`
      this.active_url = `../../../../assets/icons/active-${this.label}.svg`
    }
    else {
      this.active = false
      this.url = `../../../../assets/icons/${this.label}.svg`
      this.active_url = `../../../../assets/icons/active-${this.label}.svg`
    }

  }

  ngOnChanges(): void {
    this.getActivatedRoutes()
  }
}
